import { render, staticRenderFns } from "./DisclaimerVisio.vue?vue&type=template&id=2860f01c"
import script from "./DisclaimerVisio.vue?vue&type=script&lang=ts"
export * from "./DisclaimerVisio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports